import { Navigate } from 'react-router-dom';
import type { CSSProperties } from 'react';
import {
  IxButton,
  IxCard,
  IxCardContent,
  IxTypography,
} from '@siemens/ix-react';
import { useAuth } from '../auth/AuthProvider.js';
import { brandButtonStyle } from '../styles/brandButton.js';

const pageStyle: CSSProperties = {
  minHeight: '100vh',
  width: '100%',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  padding: '20px',
  boxSizing: 'border-box',

  background:
    'radial-gradient(ellipse at center, #FFFFFF 0%, #F7F6F3 60%, #F3F3F0 100%)',
};

const wrapperStyle: CSSProperties = {
  width: '470px',
  maxWidth: '100%',
};

const cardStyle: CSSProperties = {
  width: '100%',
  minHeight: '340px',

  background: '#FFFFFF',

  border: '1px solid #D9DDE0',
  borderRadius: '7px',

  boxShadow: '0 3px 1px rgba(0, 0, 0, 0.12)',
};

const contentStyle: CSSProperties = {
  minHeight: '340px',

  display: 'flex',
  flexDirection: 'column',

   padding: '48px 40px 28px',
  boxSizing: 'border-box',
};

const titleStyle: CSSProperties = {
  margin: '0',

  textAlign: 'left',

   fontSize: '33px',
  fontWeight: 900,
  lineHeight: '1',

  color: '#27313D',
};

const descriptionStyle: CSSProperties = {
  margin: '38px 0 38px',

  textAlign: 'left',

  fontSize: '16px',
  fontWeight: 350,
  lineHeight: '1',

  color: '#303946',
};

const buttonWrapperStyle: CSSProperties = {
  width: '100%',
  marginTop: 'auto',
};

const buttonStyle: CSSProperties = {
  ...brandButtonStyle,
  width: '100%',
  height: '45px',
  fontSize: '15px',
  fontWeight: 700,
};

export function SignIn() {
  const { account, isInitializing, signIn } = useAuth();

  if (isInitializing) {
    return null;
  }

  if (account !== null) {
    return <Navigate to="/calculate" replace />;
  }

  return (
    <main style={pageStyle}>
      <div style={wrapperStyle}>
        <IxCard variant="outline" style={cardStyle}>
          <IxCardContent style={contentStyle}>
            <IxTypography format="h1" style={titleStyle}>
              Transfer Pricing System
            </IxTypography>

            <IxTypography format="body" style={descriptionStyle}>
              Please sign in with your Siemens Entra ID account to continue.
            </IxTypography>

            <div style={buttonWrapperStyle}>
              <IxButton
                onClick={() => void signIn()}
                style={buttonStyle}
              >
                SIGN IN WITH ENTRA ID
              </IxButton>
            </div>
          </IxCardContent>
        </IxCard>
      </div>
    </main>
  );
}